<template>
  <div>
    <audit-log-group
      v-for="(wrappedAudits, date) in wrappedAuditsPerDay"
      :key="date"
      :date="date"
      :audits="wrappedAudits"
    />
  </div>
</template>

<script>
import AuditLogGroup from './audit-log-group'

const AuditLog = {
  components: {
    AuditLogGroup,
  },
  props: {
    wrappedAuditsPerDay: {
      type: Object,
      default: () => {},
    },
  },
}

export default AuditLog
</script>
